import { TIERS, type TierId } from "@golazo/shared";
import { t } from "../i18n/index.js";
import "./tierMark.css";

/**
 * La division de alguien, en pequeño, junto a su apodo: en las salas, en los
 * chats y en la lista de amigos. Es lo que hace que se vea quien es quien (y
 * que uno quiera subir). Sale de las estadisticas mundiales; quien pidio no
 * aparecer no lleva division.
 */
export const TIER_LABEL: Record<TierId, string> = {
  bronce: "Bronce",
  plata: "Plata",
  oro: "Oro",
  platino: "Platino",
  diamante: "Diamante",
  leyenda: "Leyenda",
};

function hex(n: number): string {
  return `#${n.toString(16).padStart(6, "0")}`;
}

export function tierColor(tier: TierId | null | undefined): string {
  const found = TIERS.find((x) => x.id === tier);
  return found ? hex(found.color) : "#7b8a80";
}

export function tierLabel(tier: TierId | null | undefined): string {
  return tier ? t(TIER_LABEL[tier]) : t("En colocación");
}

/** Como nodo del DOM (los chats no usan innerHTML). `null` si no tiene division. */
export function tierMarkNode(tier: TierId | null | undefined): HTMLElement | null {
  if (!tier) return null;
  const mark = document.createElement("i");
  mark.className = "tier-mark";
  mark.style.setProperty("--tier", tierColor(tier));
  mark.title = tierLabel(tier);
  mark.setAttribute("aria-label", tierLabel(tier));
  return mark;
}

export function tierMarkHtml(tier: TierId | null | undefined): string {
  if (!tier) return "";
  const label = tierLabel(tier).replace(/"/g, "&quot;");
  return `<i class="tier-mark" style="--tier:${tierColor(tier)}" title="${label}" aria-label="${label}"></i>`;
}
